import { type JsonDataItem } from 'types';

export const parseErrors = (error: any): string[] => {
  // Ensure `error` and `error.error` exist, otherwise return an empty array
  if (!error || !error.error) {
    return [];
  }

  const errorMessage = error.error;
  const isArray = (value: any): boolean => Array.isArray(value);
  const isObject = (value: any): boolean => !!(typeof value === 'object' && value !== null);
  const isString = (value: any): boolean => typeof value === 'string' || value instanceof String;

  // API errors
  if (isArray(errorMessage.errors)) {
    if (isString(errorMessage.errors[0]?.message)) {
      // Type #1 Standard multiple
      // { "errors": [{message: "text1"}, {message: "text2"}] }
      return errorMessage.errors.map((error: JsonDataItem) => error.message);
    } else if (isString(errorMessage.errors[0])) {
      // Type #2 Laravel
      // { "errors": ["text1", "text2"] }
      return errorMessage.errors;
    }
  }

  if (isObject(errorMessage.errors)) {
    // Type #3 Laravel multiple
    // { "errors": { someName1: ["text1", "text2"], someName2: ["Text3", "Text4"]} }
    return Object.values(errorMessage.errors).flat() as string[];
  }

  if (isString(errorMessage.message)) {
    // Type #4 Standard single error
    // { message: "text" }
    return [errorMessage.message];
  }

  // Form field errors
  if (isArray(errorMessage.errorFields)) {
    // { "errorFields": [{ errors: ["Field error 1"] }, { errors: ["Field error 2"] }] }
    return errorMessage.errorFields.map((field: JsonDataItem) => field.errors[0]);
  }

  // Fallback for unexpected error formats
  return ['Unexpected error'];
};
